import { render, staticRenderFns } from "./TrailerModal.vue?vue&type=template&id=dd4d20fc&scoped=true"
import script from "./TrailerModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./TrailerModal.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./TrailerModal.vue?vue&type=style&index=0&id=dd4d20fc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd4d20fc",
  null
  
)

export default component.exports